import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Anchor, Box, CheckBox, FormField, Grid, ResponsiveContext, Select, Text, TextInput } from "grommet";
import * as React from "react";
import { ColorPicker } from "../components/ThemeBuilder";
import { useReferenceData } from "../reference/ReferenceStore";

import { StatType, StatViewModel } from "./StatsStore";

const StatDetails = ({ stat, isBusy, onChange }: { stat: StatViewModel; isBusy: boolean; onChange: Function }) => {
    const [name, setName] = React.useState(stat.name || "");
    const [description, setDescription] = React.useState(stat.description || "");
    const [type, setType] = React.useState(stat.type || "");
    const [color, setColor] = React.useState(stat.color || "orange");
    const [icon, setIcon] = React.useState(stat.icon || "");
    const [invertedScoring, setInvertedScoring] = React.useState(stat.invertedScoring || false);

    React.useEffect(() => {
        onChange({ name, description, type, color, icon, invertedScoring });
    }, [name, description, type, color, icon, invertedScoring]);

    const size = React.useContext(ResponsiveContext);

    const statTypes = useReferenceData("statTypes") as StatType[];

    return (
        <div>
            <>
                <Box>
                    <Grid columns={size == "small" ? ["auto"] : ["1/2", "1/2"]} gap="small">
                        <Box>
                            <FormField label="Name">
                                <TextInput value={name} onChange={(e) => setName(e.target.value)} disabled={isBusy} />
                            </FormField>
                        </Box>
                        <Box>
                            <FormField label="Type">
                                <Select
                                    value={type}
                                    onChange={(e) => setType(e.target.value)}
                                    labelKey="displayName"
                                    disabled={isBusy}
                                    options={statTypes}
                                    children={(option, index, options, { active, disabled, selected }) => (
                                        <Box pad="1rem">
                                            <Text>{option.displayName}</Text>
                                        </Box>
                                    )}
                                    valueKey={{ key: "name", reduce: true }}
                                />
                            </FormField>
                        </Box>
                        <Box>
                            <FormField label="Description">
                                <TextInput value={description} onChange={(e) => setDescription(e.target.value)} disabled={isBusy} />
                            </FormField>
                        </Box>
                        {stat.id && (
                            <Box>
                                <FormField label="Color">
                                    <ColorPicker disabled={isBusy} style={{ backgroundColor: color }}>
                                        <input type="color" value={color} disabled={isBusy} onChange={(e) => setColor(e.target.value)} />
                                    </ColorPicker>
                                </FormField>
                                <FormField label="Inverted Scoring">
                                    <CheckBox checked={invertedScoring} onChange={(e) => setInvertedScoring(e.target.checked)} disabled={isBusy} />
                                    <Text>Lower is better</Text>
                                </FormField>
                            </Box>
                        )}
                        <Box>
                            <FormField
                                label="Icon"
                                help={
                                    <Anchor href="https://fontawesome.com/search?s=duotone" target={"_blank"}>
                                        List of Icons<FontAwesomeIcon icon={["fad", "arrow-up-right-from-square"]}></FontAwesomeIcon>
                                    </Anchor>
                                }
                            >
                                <TextInput value={icon} onChange={(e) => setIcon(e.target.value)} disabled={isBusy} />
                            </FormField>
                        </Box>
                    </Grid>
                </Box>
            </>
        </div>
    );
};

export default StatDetails;
